app.controller('programCtrl', function ($uibModal, $http) {
    const self = this;

    const renderError = (err) => {
        console.error('Unexpected Error: ', err);
    };

    self.needPremium = (feature) => {
        $uibModal
            .open({
                component: 'need-premium',
                windowClass: 'need-premium-modal',
                animation: false,
                size: 'md',
                resolve: {
                    feature: function () {
                        return feature;
                    }
                }
            })
            .result
            .then(() => {

            }, () => {

            })
            .catch(renderError);
    };

    self.needLogin = (feature) => {
        $uibModal
            .open({
                component: 'need-login',
                windowClass: 'need-premium-modal',
                animation: false,
                size: 'md',
                resolve: {
                    feature: function () {
                        return feature;
                    }
                }
            })
            .result
            .then(() => {

            }, () => {

            })
            .catch(renderError);
    };

});
